// extracted by mini-css-extract-plugin
module.exports = {"option_icon":"search-place-option-new_option_icon__V_nJs","option_link":"search-place-option-new_option_link__MozJ_"};